// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__7olKE","Label":"Input_Label__2_-g2","InputElement":"Input_InputElement__3IZIz","Invalid":"Input_Invalid__2ZQgs"};